// extracted by mini-css-extract-plugin
module.exports = {"container":"PurchasingHistory_container__2Tid9","header":"PurchasingHistory_header__3TZL_","item":"PurchasingHistory_item__2sMCb","spin":"PurchasingHistory_spin__2YvY6"};